<app-legal-person-validated-form [formGroupInput]="investorForm" />
